import React from 'react';
import { Icon, IconsEnum } from 'components/Icons';

import { CartTipoVenditaEnum } from 'types/swagger';
import { isTipoVenditaQuotaFissa } from 'features/ippica/components/ippicaTicket/utils/calcoloCarrello/utils';
import { removeTicketAndCampiSelected } from 'features/ippica/actions';
import styles from './IppicaTicketItemEsito.module.scss';
import { useAppDispatch } from 'lib/centralStore';

export type IppicaTicketItemEsitoProps = {
  descrizioneTipoScommessa?: string;
  descrizioneEsito?: string;
  esitoId?: string;
  quotaDividedHundred?: number;
  cancelBtn: boolean;
  tipoVendita?: CartTipoVenditaEnum;
  mappe?: number[][];
  cavalliMap?: {
    [key: string]: string;
  };
};
export const IppicaTicketItemEsito = ({
  descrizioneTipoScommessa,
  descrizioneEsito,
  esitoId,
  quotaDividedHundred,
  cancelBtn,
  tipoVendita,
  mappe,
  cavalliMap,
}: IppicaTicketItemEsitoProps) => {
  const dispatch = useAppDispatch();

  return (
    <React.Fragment key={`ticket-esito-${esitoId}`}>
      <li className={styles.scommessaItem}>
        <div className={styles.firstRow}>
          {tipoVendita && isTipoVenditaQuotaFissa(tipoVendita) ? (
            <p className={styles.scommessa}>
              {descrizioneTipoScommessa}:<span className={styles.esito}>{descrizioneEsito}</span>
            </p>
          ) : (
            <p className={styles.scommessa}>{descrizioneTipoScommessa}</p>
          )}
          <div className={styles.quota}>
            {quotaDividedHundred && (quotaDividedHundred < 10 ? quotaDividedHundred.toFixed(2) : quotaDividedHundred)}
            {cancelBtn && (
              <button
                type="button"
                className={`${styles.cancelBtn}`}
                onClick={() => dispatch(removeTicketAndCampiSelected(esitoId))}
              >
                <Icon
                  iconId={IconsEnum.CANCEL_FULL}
                  className={styles.cancelIcon}
                  color={'var(--color-on-bg-secondary)'}
                />
              </button>
            )}
          </div>
        </div>
        {mappe && (
          <div className={styles.secondRow}>
            {mappe.map((esiti, index) => {
              return (
                <div key={index} className={styles.esito}>
                  {esiti.map((esito, index) => {
                    return cavalliMap ? (
                      <div key={index} className={styles.cavallo}>
                        {esito}: {cavalliMap[esito]}
                      </div>
                    ) : null;
                  })}
                </div>
              );
            })}
          </div>
        )}
      </li>
    </React.Fragment>
  );
};